import { computed } from 'vue';
import { useRoute } from 'vue-router';

// QuePasa boolean options travel as true/false/1/-1; absent means "not
// configured". Normalizes any of those into true / false / null.
export const castTristate = value => {
  if (value === true || value === 'true' || value === 1) return true;
  if (value === false || value === 'false' || value === -1) return false;
  return null;
};

// Shared endpoint builder for the QuePasa Channel settings tabs.
// `getInbox` is a function returning the current inbox prop.
export function useQuepasaChannelApi(getInbox) {
  const route = useRoute();
  const accountId = computed(
    () => route?.params?.accountId || route?.params?.account_id
  );
  const endpoint = (path = '') =>
    `/api/v1/accounts/${accountId.value}/quepasa_channel/${getInbox()?.id}${path}`;

  return { accountId, endpoint, http: window.axios };
}
